// extracted by mini-css-extract-plugin
export default {"mobile-weather-details":"MobileWeatherDetails_mobile-weather-details__DNwtQ"};